import React from 'react';
import {connect} from 'react-redux';
import SVG from 'react-inlinesvg';
import { toast } from 'react-toastify'

import { PaymentModel, CompanyModel, UserModel, CompanySelector } from '/app/src/model'
import {Flex} from '/app/src/component';
import PaymentModal from './PaymentModal'
import ModalTemplate from './ModalTemplate'
import LoadingScreen from './LoadingScreen'
import {HasShown} from '/app/src/lib';

class PaymentModalContainer extends React.Component {
    constructor(props) {
        super(props)
        this.onFinish = this.onFinish.bind(this)
        this.state = {
            isPosting: false
        }
    }

    componentDidMount() {
        this.props.dispatch(dispatchPaymentInfo)
        this.props.dispatch(dispatchBillingInfoRead)

    }

    render() {
        const {isLoading, isBlockScreen} = this.props
        const {isPosting} = this.state
        let headerIcon = '/images/upgrade.svg'
        let headerText = 'Uppgradera'
        if (isBlockScreen) {
            headerIcon = '/images/upgrade.svg'
            headerText = 'Återuppta Jibber'
        }
        const headerStyle = {
            width: '100%',
            height: '100%',
            fontSize: '30px',
            color: 'white',
            fontWeight: 500
        }
        const iconStyle = {
            fill: 'white',
            width: '35px',
            height: '35px',
            marginRight: '10px'
        }
        const header = (
            <Flex {...headerStyle} center>
                <SVG cacheGetRequests={true} style={iconStyle}  src={headerIcon} />
                {headerText}
            </Flex>
        )
        return (
            <ModalTemplate header={header}>
                { (isLoading || isPosting)
                    ? <LoadingScreen/>
                    : <PaymentModal {...this.props} onFinish={this.onFinish}/>
                }
            </ModalTemplate>
        )
    }

    onFinish(params) {
        this.setState({isPosting: true})
        const onFinishRequest = this.props.isBlockScreen
            ? CompanyModel.pricePlanResume(params.period, params.subscription, params.plan)
            : CompanyModel.pricePlanCompleteUpgrade(params.period, params.subscription, params.plan)
        this.props.dispatch(onFinishRequest)
        .then( () => {
            if(this.props.hasInfo){
                this.props.dispatch(CompanyModel.billingPut(
                    false,
                    params.companyName,
                    params.address,
                    params.email,
                    params.city,
                    params.orgNbr,
                    params.postalCode,
                    params.country
                ))
            } else {
                this.props.dispatch(CompanyModel.billingPost(
                    false,
                    params.companyName,
                    params.address,
                    params.email,
                    params.city,
                    params.orgNbr,
                    params.postalCode,
                    params.country
                ))
            }
        })
        .then( () => {
            HasShown.setHasShown('welcomeModal', false)
            this.props.dispatch(UserModel.logout())
            toast.success("Dina nya kontouppgifter är sparade. Logga in för att se ändringarna.")
        })
        .catch( () => {
            this.setState({isLoading: false})
            toast.error("Något gick fel. Kontakta oss så vi kan kolla närmare på problemet.")
        })
    }
}

const {dispatcher: dispatchPaymentInfo, selector: paymentInfoSelector} = PaymentModel.paymentSpecsRead()
const {dispatcher: dispatchBillingInfoRead, selector: billingInfoSelector} = CompanyModel.billingInfoRead()

function mapStateToProps(state, props) {
    let isLoading = false
    if (!paymentInfoSelector(state).network.get('fetched')) isLoading = true
    if (!billingInfoSelector(state).network.get('fetched')) isLoading = true
    const hasInfo = CompanySelector.getHasBillingInfo(state)
    return { isLoading, hasInfo }
}

export default connect(mapStateToProps, null)(PaymentModalContainer);



// WEBPACK FOOTER //
// ./src/component/Modal/PaymentModal/index.js